import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
function getInitials(firstName, lastName) {
    return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
}
/**
 * Circular student avatar. Shows the photo when available and falls back to
 * initials — including when the (short-lived, signed) photo URL has expired or
 * the image otherwise fails to load. Avatars live in a private bucket and are
 * served as 15-min signed URLs, so a stale cached URL must degrade gracefully.
 */
export function StudentAvatar({ url, firstName, lastName, className = 'h-10 w-10 text-sm', alt = '', }) {
    const [failed, setFailed] = useState(false);
    // A freshly signed URL should get another chance to load.
    useEffect(() => setFailed(false), [url]);
    const showImg = Boolean(url) && !failed;
    return (_jsxs("div", { className: `relative flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-gradient-to-br from-brand to-brand-light font-semibold text-white ${className}`, children: [_jsx("span", { children: getInitials(firstName, lastName) }), showImg && (_jsx("img", { src: url, alt: alt, onError: () => setFailed(true), className: "absolute inset-0 h-full w-full object-cover" }))] }));
}
//# sourceMappingURL=StudentAvatar.js.map